import React from 'react';

export const SmallContext = React.createContext(false);

SmallContext.isSmall = (scope) => {
  const { context, props: { small: prop } = {} } = scope || {};
  const isContextSet = typeof context === 'boolean';

  //Allow prop overrides
  return prop === false || !isContextSet ? prop || false : context || prop;
};
